<template>
<div class="ew-page">
  <navbar v-if="!isLoadingShippingOptions"></navbar>

  <div v-if="isLoadingShippingOptions" class="ew-loading">
    <img src="@/assets/images/loading.gif" alt="Cargando...">
    <p>Espere un momento, estamos obteniendo los mejores precios para tu paquete</p>
  </div>

  <div class="ew-page__body" v-if="!isLoadingShippingOptions">
    <div class="ew-card ew-wizard">
      <ol class="ew-stepper">
        <li
          class="ew-stepper__step"
          v-for="(label, i) in ['Servicio', 'Direcciones', 'Pago']"
          :key="label"
          :class="{ 'is-active': currentStep === i + 1, 'is-done': currentStep > i + 1 }"
        >
          <span class="ew-stepper__index">{{ i + 1 }}</span>
          <span class="ew-stepper__label">{{ label }}</span>
          <span class="ew-stepper__line" v-if="i < 2"></span>
        </li>
      </ol>

      <!-- Paso 1: Selección de proveedor de servicio -->
      <section v-if="currentStep === 1">
        <div v-if="!isLoadingShippingOptions && visibleShipmentOptions.length > 0">
          <h3 class="ew-section-title">Selecciona tu servicio de paquetería</h3>

          <div class="ew-step-layout">
            <div class="ew-step-layout__main ew-carrier-list">
              <div class="ew-carrier-card" v-for="(so, i) in visibleShipmentOptions" v-bind:key="i">
                <div class="ew-carrier-card__logo">
                  <img :src="so.carrier_logo_url_svg" alt="">
                </div>

                <div class="ew-carrier-card__info">
                  <div class="ew-carrier-card__badges" v-if="i === 0 || isFastestOption(so)">
                    <span class="ew-carrier-card__badge ew-carrier-card__badge--price" v-if="i === 0">Mejor precio</span>
                    <span class="ew-carrier-card__badge ew-carrier-card__badge--speed" v-if="isFastestOption(so)">Más rápido</span>
                  </div>
                  <div class="ew-carrier-card__name">{{ so.carrier_service_name }}</div>
                  <div class="ew-carrier-card__transit" :class="{ 'ew-area-remote': so.is_remote }">{{ getTransitInterval(so.total_transit_days, so.carrier, so.carrier_service_name, so.is_remote) }}</div>
                  <div class="ew-carrier-card__eta" v-if="!so.is_remote">Llega {{ getEstimatedDeliveryDate(so.total_transit_days) }}</div>
                  <div class="ew-carrier-card__note">Es necesario imprimir guías *</div>
                  <div class="ew-carrier-card__note--warning" v-if="so.note">{{ so.note }}</div>
                </div>

                <div class="ew-carrier-card__price">
                  <p class="ew-carrier-card__amount">{{ formatMXN(so.total_amount) }}</p>
                  <button type="button" class="ew-carrier-card__detail-btn" :id="'detail-' + i">Ver desglose</button>
                  <b-popover :target="'detail-' + i" placement="top" title="Desglose de precio" triggers="click blur">
                    <div class="ew-price-breakdown">
                      <div class="ew-price-breakdown__row" v-for="(service, k) in so.services" v-bind:key="k">
                        <span>{{ service.service_name }}:</span>
                        <span>{{ formatMXN(service.price) }}</span>
                      </div>
                      <div class="ew-price-breakdown__total">
                        <span>Total:</span>
                        <span>{{ formatMXN(so.total_amount) }}</span>
                      </div>
                    </div>
                  </b-popover>
                </div>

                <button type="button" class="ew-btn-primary" @click="catchOption(i)">Enviar</button>
              </div>

              <div class="ew-wizard__actions ew-wizard__actions--end">
                <router-link class="ew-btn-outline" to="/">Regresar</router-link>
              </div>
            </div>

            <aside class="ew-card ew-summary-card ew-step-layout__aside">
              <p class="ew-card-title">Resumen del envío</p>
              <div class="ew-summary-detail">
                <div class="ew-summary-row"><span>Tipo de paquete</span><span>{{ (quotingRequestBody && quotingRequestBody.package_type === 'document') ? 'Sobre' : 'Paquete' }}</span></div>
                <div class="ew-summary-row"><span>Peso</span><span>{{ weightTotal }} kg</span></div>
              </div>
            </aside>
          </div>
        </div>

        <div class="ew-empty" v-if="!isLoadingShippingOptions && visibleShipmentOptions.length <= 0">
          <img src="@/assets/images/envi-shadow.png" class="ew-empty__image" alt="">
          <p class="ew-empty__text">
            No tenemos el servicio disponible, para más información llamar al
            <strong>3317547337</strong>
          </p>
        </div>
      </section>

      <!-- Paso 2: Ingresar direcciones -->
      <section v-if="currentStep === 2">
        <form @submit.prevent="saveShipment" novalidate>
          <h3 class="ew-section-title">Ingresar direcciones</h3>

          <div class="ew-step-layout">
            <div class="ew-step-layout__main">
              <div class="ew-addr-grid">
                <div class="ew-address-panel">
                  <div class="ew-address-panel__header">
                    <span>Origen</span>
                    <span class="ew-flag-badge ew-flag-badge--header" aria-hidden="true">
                      <img :src="origin.flag" alt="" class="ew-flag">
                      MX
                    </span>
                  </div>
                  <div class="ew-address-panel__body">
                    <div class="ew-form__field">
                      <label class="ew-label">Nombre y apellido *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.full_name.$error }" @blur="$v.origin_direction.full_name.$touch()" minlength="2" maxlength="35" v-model.trim="origin_direction.full_name" placeholder="John Doe" required>
                      <div class="ew-field-error" v-if="$v.origin_direction.full_name.$error">Ingresa el nombre completo</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Teléfono *</label>
                      <input type="tel" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.phone.$error }" @blur="$v.origin_direction.phone.$touch()" pattern="[0-9]{10,25}" v-model.trim="origin_direction.phone" placeholder="123456789" required>
                      <div class="ew-field-error" v-if="$v.origin_direction.phone.$error">Ingresa un teléfono válido</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Correo electrónico *</label>
                      <input type="email" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.email.$error }" @blur="$v.origin_direction.email.$touch()" v-model.trim="origin_direction.email" placeholder="nombre@tucorreo.com" required>
                      <div class="ew-field-error" v-if="$v.origin_direction.email.$error">Ingresa un correo válido</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Calle *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.address.$error }" @blur="$v.origin_direction.address.$touch()" minlength="2" maxlength="25" v-model.trim="origin_direction.address" placeholder="Av. Josefa Ortiz" required>
                      <div class="ew-field-error" v-if="$v.origin_direction.address.$error">Ingresa la calle</div>
                    </div>
                    <div class="ew-form__row">
                      <div class="ew-form__field">
                        <label class="ew-label">No. Ext *</label>
                        <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.number.$error }" @blur="$v.origin_direction.number.$touch()" minlength="1" maxlength="5" v-model.trim="origin_direction.number" placeholder="309" required>
                      </div>
                      <div class="ew-form__field">
                        <label class="ew-label">No. Int</label>
                        <input type="text" class="ew-input ew-input--block" minlength="1" maxlength="5" v-model.trim="origin_direction.intNumber" placeholder="J-45">
                      </div>
                    </div>
                    <div class="ew-field-error" v-if="$v.origin_direction.number.$error">Ingresa el número exterior</div>
                    <div class="ew-form__field">
                      <label class="ew-label">Referencia <small>(opcional)</small></label>
                      <input type="text" class="ew-input ew-input--block" minlength="2" maxlength="35" v-model.trim="origin_direction.reference_of_origin" placeholder="Casa verde">
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Colonia *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.colony.$error }" @blur="$v.origin_direction.colony.$touch()" maxlength="35" v-model.trim="origin_direction.colony" placeholder="Independencia" required>
                      <div class="ew-field-error" v-if="$v.origin_direction.colony.$error">Ingresa la colonia</div>
                    </div>
                    <div class="ew-form__row">
                      <div class="ew-form__field">
                        <label class="ew-label">Código postal *</label>
                        <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.postal_code.$error }" @blur="$v.origin_direction.postal_code.$touch()" maxlength="12" v-model.trim="origin_direction.postal_code" required>
                      </div>
                      <div class="ew-form__field">
                        <label class="ew-label">Estado y ciudad *</label>
                        <input type="text" class="ew-input ew-input--block" minlength="2" maxlength="35" v-model.trim="origin_direction.city" required disabled>
                      </div>
                    </div>
                    <div class="ew-field-error" v-if="$v.origin_direction.postal_code.$error">Ingresa el código postal</div>
                    <label class="ew-checkbox-row" v-if="isLoging === true">
                      <input type="checkbox" class="ew-checkbox" @change="setSaveLocationOrigen">
                      <span>Guardar dirección</span>
                    </label>
                  </div>
                </div>

                <div class="ew-address-panel">
                  <div class="ew-address-panel__header">
                    <span>Destino</span>
                    <span class="ew-flag-badge ew-flag-badge--header" aria-hidden="true">
                      <img :src="destination.flag" alt="" class="ew-flag">
                      MX
                    </span>
                  </div>
                  <div class="ew-address-panel__body">
                    <div class="ew-form__field">
                      <label class="ew-label">Nombre y apellido *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.full_name.$error }" @blur="$v.destination_direction.full_name.$touch()" minlength="2" maxlength="35" v-model.trim="destination_direction.full_name" placeholder="John Doe" required>
                      <div class="ew-field-error" v-if="$v.destination_direction.full_name.$error">Ingresa el nombre completo</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Teléfono *</label>
                      <input type="tel" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.phone.$error }" @blur="$v.destination_direction.phone.$touch()" pattern="[0-9]{10,25}" v-model.trim="destination_direction.phone" placeholder="123456789" required>
                      <div class="ew-field-error" v-if="$v.destination_direction.phone.$error">Ingresa un teléfono válido</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Correo electrónico *</label>
                      <input type="email" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.email.$error }" @blur="$v.destination_direction.email.$touch()" v-model.trim="destination_direction.email" placeholder="nombre@tucorreo.com" required>
                      <div class="ew-field-error" v-if="$v.destination_direction.email.$error">Ingresa un correo válido</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Calle *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.address.$error }" @blur="$v.destination_direction.address.$touch()" minlength="2" maxlength="25" v-model.trim="destination_direction.address" placeholder="Av. Josefa Ortiz" required>
                      <div class="ew-field-error" v-if="$v.destination_direction.address.$error">Ingresa la calle</div>
                    </div>
                    <div class="ew-form__row">
                      <div class="ew-form__field">
                        <label class="ew-label">No. Ext *</label>
                        <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.number.$error }" @blur="$v.destination_direction.number.$touch()" minlength="2" maxlength="5" v-model.trim="destination_direction.number" placeholder="309" required>
                      </div>
                      <div class="ew-form__field">
                        <label class="ew-label">No. Int</label>
                        <input type="text" class="ew-input ew-input--block" minlength="2" maxlength="5" v-model.trim="destination_direction.intNumber" placeholder="J-45">
                      </div>
                    </div>
                    <div class="ew-field-error" v-if="$v.destination_direction.number.$error">Ingresa el número exterior</div>
                    <div class="ew-form__field">
                      <label class="ew-label">Referencia <small>(opcional)</small></label>
                      <input type="text" class="ew-input ew-input--block" minlength="2" maxlength="35" v-model.trim="destination_direction.reference_of_origin" placeholder="Casa verde">
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Colonia *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.colony.$error }" @blur="$v.destination_direction.colony.$touch()" minlength="5" maxlength="35" placeholder="Independencia" v-model.trim="destination_direction.colony" required>
                      <div class="ew-field-error" v-if="$v.destination_direction.colony.$error">Ingresa la colonia</div>
                    </div>
                    <div class="ew-form__row">
                      <div class="ew-form__field">
                        <label class="ew-label">Código postal *</label>
                        <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.postal_code.$error }" @blur="$v.destination_direction.postal_code.$touch()" maxlength="12" v-model.trim="destination_direction.postal_code" required>
                      </div>
                      <div class="ew-form__field">
                        <label class="ew-label">Estado y ciudad *</label>
                        <input type="text" class="ew-input ew-input--block" minlength="5" maxlength="35" v-model.trim="destination_direction.city" required disabled>
                      </div>
                    </div>
                    <div class="ew-field-error" v-if="$v.destination_direction.postal_code.$error">Ingresa el código postal</div>
                    <label class="ew-checkbox-row" v-if="isLoging === true">
                      <input type="checkbox" class="ew-checkbox" @change="setSaveLocationDestination">
                      <span>Guardar dirección</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="ew-card ew-content-card">
                <p class="ew-card-title">Contenido del envío</p>
                <input
                  type="text"
                  class="ew-input ew-input--block"
                  :class="{ 'is-invalid': $v.description_of_the_content.$error }"
                  @blur="$v.description_of_the_content.$touch()"
                  v-model="description_of_the_content"
                  placeholder="Descripción del contenido"
                  required
                >
                <div class="ew-field-error" v-if="$v.description_of_the_content.$error">Describe qué envías</div>
              </div>

              <div class="ew-wizard__actions">
                <button class="ew-btn-outline" type="button" @click="prevStep">Anterior</button>
                <button type="submit" class="ew-btn-primary" :disabled="newShip">Siguiente</button>
              </div>
            </div>

            <aside class="ew-card ew-summary-card ew-step-layout__aside">
              <div class="ew-summary-card__carrier">
                <img :src="visibleShipmentOptions[selectedShippingOptionIndex].carrier_logo_url_svg" alt="">
                <p>{{ visibleShipmentOptions[selectedShippingOptionIndex].carrier_service_name }}</p>
              </div>

              <div class="ew-summary-route">
                <div class="ew-summary-route__row">
                  <span>De:</span>
                  <div>
                    <p>{{ origin_direction.postal_code }} {{ getCity(origin_direction.city) }}</p>
                    <p>México</p>
                  </div>
                </div>
                <div class="ew-summary-route__row">
                  <span>A:</span>
                  <div>
                    <p>{{ destination_direction.postal_code }} {{ getCity(destination_direction.city) }}</p>
                    <p>México</p>
                  </div>
                </div>
              </div>

              <div class="ew-summary-detail">
                <div class="ew-summary-row"><span>Tipo de paquete</span><span>{{ (quotingRequestBody && quotingRequestBody.package_type === 'document') ? 'Sobre' : 'Paquete' }}</span></div>
                <div class="ew-summary-row"><span>Peso total</span><span>{{ weightTotal }} kg</span></div>
                <div class="ew-summary-row" v-if="description_of_the_content"><span>Contenido</span><span>{{ description_of_the_content }}</span></div>
                <div class="ew-summary-row"><span>Precio neto</span><span>{{ formatMXN(netPrice) }}</span></div>
                <div class="ew-summary-row" v-if="overweight > 0"><span>Sobrepeso anterior</span><span>{{ overweight }} kg</span></div>
                <div class="ew-summary-row" v-if="cost_overweight > 0"><span>Precio sobrepeso</span><span>{{ formatMXN(cost_overweight) }}</span></div>
                <div class="ew-summary-total"><span>Total</span><span>{{ formatMXN(total) }}</span></div>
              </div>
            </aside>
          </div>
        </form>
      </section>

      <!-- Paso 3: Selecciona pago -->
      <section v-if="currentStep === 3">
        {{ addEventPixeleFacebook() }}
        <div class="ew-step-layout">
          <div class="ew-card ew-pay-card ew-step-layout__main">
            <p class="ew-card-title">Método de pago</p>

            <form @submit.prevent>
              <div class="ew-pay-options">
                <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'paypal' }">
                  <input type="radio" name="paymentMethod" @change="getLinkPaypal" v-on:click="paymentMethod = 'paypal'">
                  <img class="ew-pay-option__logo" src="@/assets/images/paypal.png" alt="">
                  <span class="ew-pay-option__label">PayPal</span>
                </label>

                <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'paypal-plus' }">
                  <input type="radio" name="paymentMethod" v-on:click="paymentMethod = 'paypal-plus'">
                  <img class="ew-pay-option__logo" src="@/assets/images/card-paypal.png" alt="">
                  <span class="ew-pay-option__label">Pago con tarjeta</span>
                </label>

                <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'oxxo' }">
                  <input type="radio" name="paymentMethod" v-on:click="paymentMethod = 'oxxo'">
                  <img class="ew-pay-option__logo" src="@/assets/images/oxxopay_brand.png" alt="">
                  <span class="ew-pay-option__label">OXXO</span>
                </label>
              </div>

              <p class="ew-pay-hint" v-if="paymentMethod === 'oxxo'">Generaremos un código de barras. Pagas en cualquier tienda OXXO y tu guía se activa en cuanto se confirme el pago (puede tardar hasta un día hábil).</p>
              <p class="ew-pay-hint" v-if="paymentMethod === 'paypal-plus'">Ingresa los datos de tu tarjeta en la ventana segura de PayPal. No guardamos los datos de tu tarjeta.</p>

              <div class="ew-wizard__actions">
                <button class="ew-btn-outline" type="button" @click="deleteShipment">Anterior</button>

                <a
                  :href="paypalLink"
                  class="ew-btn-primary"
                  v-if="paypalLink !== '' && paymentMethod === 'paypal'"
                >Pagar</a>

                <button
                  type="button"
                  id="miniBrowserInitiateCheckout"
                  class="ew-btn-primary"
                  @click="initIframePayPalPlus"
                  v-if="paypalpluslink !== '' && paymentMethod === 'paypal-plus'"
                >Pagar con tarjeta</button>

                <button
                  type="button"
                  class="ew-btn-primary"
                  v-if="paymentMethod === 'oxxo'"
                  v-on:click="paymentOXXO"
                  :disabled="payDisabled"
                >Pagar</button>
              </div>
              <p class="ew-pay-security">Pago seguro. Te enviaremos la guía a tu correo en cuanto se confirme el pago.</p>
            </form>
          </div>

          <aside class="ew-card ew-summary-card ew-step-layout__aside">
            <p class="ew-card-title">Resumen de compra</p>
            <div class="ew-summary-card__carrier">
              <img :src="visibleShipmentOptions[selectedShippingOptionIndex].carrier_logo_url_svg" alt="">
              <p>{{ visibleShipmentOptions[selectedShippingOptionIndex].carrier_service_name }}</p>
            </div>
            <div class="ew-summary-detail">
              <div class="ew-summary-row">
                <span>Destino</span>
                <span>{{ destination_direction.full_name }}<br>C.P. {{ destination_direction.postal_code }}</span>
              </div>
              <div class="ew-summary-row"><span>Tipo de paquete</span><span>{{ (quotingRequestBody && quotingRequestBody.package_type === 'document') ? 'Sobre' : 'Paquete' }}</span></div>
              <div class="ew-summary-row"><span>Peso total</span><span>{{ weightTotal }} kg</span></div>
              <div class="ew-summary-row" v-if="description_of_the_content"><span>Contenido</span><span>{{ description_of_the_content }}</span></div>
              <div class="ew-summary-total"><span>Total</span><span>{{ visibleShipmentOptions[selectedShippingOptionIndex].currency }} {{ formatMXN(total) }}</span></div>
            </div>
          </aside>
        </div>
      </section>
    </div>
  </div>

  <footer class="ew-footer ew-footer--primary" v-if="!isLoadingShippingOptions">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6 col-md-3">
          <ul>
            <li>
              <h4>Empresa</h4>
            </li>
            <li>
              <router-link to="/politicas-de-privacidad">Políticas</router-link>
            </li>
            <li>
              <router-link to="/terminos-de-servicio">Términos y Condiciones</router-link>
            </li>
          </ul>
        </div>

        <div class="col-sm-6 col-md-3">
          <ul>
            <li>
              <h4>INTEGRACIONES</h4>
            </li>
            <li>
              <a href="#">Guía de integraciones</a>
            </li>
          </ul>
        </div>

        <div class="col-sm-6 col-md-3">
          <ul>
            <li>
              <h4>SOPORTE</h4>
            </li>
            <li>
              <a href="#">Ayuda con logística</a>
            </li>
            <li>
              <router-link to="/contactanos">Contacto</router-link>
            </li>
            <li>
              <router-link to="/preguntas-frecuentes">Preguntas frecuentes</router-link>
            </li>
          </ul>
        </div>

        <div class="col-sm-6 col-md-3">
          <a href="https://www.facebook.com/enviosweb.mx/" class="ew-icon pl1" target="_blank">
            <img src="@/assets/images/Facebook.svg" alt>
          </a>
          <a href="https://www.instagram.com/enviosweb/" class="ew-icon" target="_blank">
            <img src="@/assets/images/Instagram.svg" alt>
          </a>
          <a
            href="https://www.youtube.com/channel/UCLwSwMd-czMjC60ajlv-zzQ"
            class="ew-icon"
            target="_blank"
          >
            <img src="@/assets/images/youtube-.svg" alt>
          </a>
          <p class="txt-f1 pdn-l1">
            Dudas, escríbenos a
            <a
              href="mailto:hola@enviosweb.mx"
              title="Envíanos un mensaje"
            >hola@enviosweb.mx</a>
          </p>
          <p class="pdn-l1">Horario de servicio de 9:00 a 18:00 hrs de lunes a viernes</p>
        </div>
      </div>
    </div>
  </footer>
  <div id="ppplusDiv"></div>
</div>
</template>

<script>
import axios from "axios";
import commons from "../commons";
import api from "../commons/api";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Navbar from "./Navbar";
import FooterSimple from "./FooterSimple";
import service from "../commons/api";
import { formatMXN } from "../commons/currency";
import moment from "moment";
import "moment/locale/es";
import { required, email, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  name: "NewShipmentFlowFromHome",
  data() {
    return {
      saveLocationOrigen : false,
      saveLocationDestination : false,
      paypalplay:null,
      paypalpluslink:"",
      newShip: false,
      idUser: null,
      isLoging: false,
      isOpenDetail: [],
      paymentMethod: "",
      payDisabled: false,
      quotingLocked: true,
      paypalLink: "",
      payment_id:"",
      shipmentId: null,
      countries: [],
      origin: {
        country_code: "MX",
        flag: "https://restcountries.eu/data/mex.svg",
        input: ""
      },
      destination: {
        country_code: "MX",
        flag: "https://restcountries.eu/data/mex.svg",
        input: ""
      },
      originSuggestions: [],
      destinationSuggestions: [],
      step: 1,
      selectedShippingOptionIndex: -1,
      availableCarriers: [
        {
          label: "DHL",
          value: "dhl"
        },
        {
          label: "Redpack",
          value: "Redpack"
        },
        {
          label: "FedEx",
          value: "fedex"
        },
         {
          label: "AM/PM",
          value: "ampm"
        },
        {
         label: "Estafeta",
         value: "Estafeta"
        }
      ],
      visibleShipmentSpeed: [],
      visibleCarriers: [],
      visibleShipmentOptions: [],
      origin_direction: {
        full_name: "",
        email: "",
        phone: "",
        address: "",
        number: '',
        intNumber: '',
        reference_of_origin: "",
        colony: "",
        postal_code: "",
        state_code: "",
        city: "",
        country_code: "MX"
      },
      destination_direction: {
        full_name: "",
        email: "",
        phone: "",
        address: "",
        number: '',
        intNumber: '',
        reference_of_origin: "",
        colony: "",
        postal_code: "",
        state_code: "",
        state_short: "",
        city: "",
        country_code: "MX"
      },
      shipment_ecommerce: null,
      description_of_the_content: "",
      package_insurance: false,
      insurance_information: {
        package_value: null,
        responsible_for_the_package: null,
        mail_responsible: null,
        cost: null
      },
      parcels: [
        {
          depth: "",
          width: "",
          height: "",
          weight: ""
        }
      ],
      requestBody: {
        origin_direction: {
          country_code: "",
          postal_code: "",
          city: "",
          suburb: ""
        },

        parcels: [
          {
            weight: "",
            height: "",
            depth: "",
            width: ""
          }
        ],
        destination_direction: {
          country_code: "",
          postal_code: "",
          city: "",
          suburb: ""
        },
        insured_value: "",
        insured_value_currency: "MXN"
      },
      weightTotal: 0,
      netPrice: 0,
      total: 0,
      overweight: 0,
      cost_overweight: 0,
      user: {
        first_names: "",
        last_names: "",
        email: "",
        active: false
      }
    };
  },
  watch: {
    visibleCarriers: function(oldValue, newValue) {
      let vc = [];
      let vss = [];

      if (!this.visibleCarriers.length) {
        vc = this.availableCarriers.map(c => c.value);
      } else {
        vc = this.visibleCarriers;
      }

      if (!this.visibleShipmentSpeed.length) {
        vss = ["0-1", "1-2", "2-4", "2-5"];
      } else {
        vss = this.visibleShipmentSpeed;
      }
      this.filter(vc, vss);
    },
    visibleShipmentSpeed: function(oldValue, newValue) {
      let vc = [];
      let vss = [];

      if (!this.visibleCarriers.length) {
        vc = this.availableCarriers.map(c => c.value);
      } else {
        vc = this.visibleCarriers;
      }

      if (!this.visibleShipmentSpeed.length) {
        vss = ["0-1", "1-2", "2-4", "2-5"];
      } else {
        vss = this.visibleShipmentSpeed;
      }
      this.filter(vc, vss);
    },
    shippingOptions: function(oldValue, newValue) {
      if (newValue.length) {
        this.visibleShipmentOptions = newValue;
      } else {
        this.visibleShipmentOptions = this.shippingOptions;
      }
    },
    "origin_direction.full_name": function(newValue, oldValue) {
      if (!this.isLoging) {
        let [first_name, last_name] = newValue.split(" ");
        this.user.first_names = first_name;
        this.user.last_names = last_name === undefined ? first_name : last_name;
      }else{
        let [first_name, last_name] = newValue.split(" ");
        this.user.first_names = first_name;
        this.user.last_names = last_name === undefined ? first_name : last_name;
      }
    },
    "origin_direction.email": function(newValue, oldValue) {
      if (!this.isLoging) {
        this.user.email = this.origin_direction.email;
      }else{
        this.user.email = this.origin_direction.email;
      }
    }
  },
  methods: {
    formatMXN,
    getEstimatedDeliveryDate(transitDays) {
      return moment().add(transitDays, 'days').format('dddd D [de] MMMM')
    },
    isFastestOption(so) {
      if (!this.visibleShipmentOptions.length) return false
      const min = Math.min(...this.visibleShipmentOptions.map(o => o.total_transit_days))
      return so.total_transit_days === min
    },
    paymentOXXO() {
      if ("oxxo" === this.paymentMethod) {
        this.payDisabled = true;
        axios
          .post(
            `${commons.apiURL}/api/v1/payments/conekta/oxxo/${this.shipmentId}`,
            { email: this.user.email }
          )
          .then(response => {
            if (response.data.message === "ok") {
              this.payDisabled = false;
              this.$router.push({
                path: "/payments/result/success",
                query: {
                  oxxo: "true",
                  reference: response.data.reference,
                  email: this.user.email
                }
              });
            } else {
              this.$router.push({
                path: "/payments/result/error",
                query: { oxxo: "false" }
              });
            }
          });
      }
    },
    filterNameService(name) {
      if (name) {
      } else if (name) {
      }
    },
    selectedShippingOptionEvent(index) {
      if (this.selectedShippingOptionIndex === index) {
        this.selectedShippingOptionIndex = -1;
      } else {
        this.selectedShippingOptionIndex = index;
      }
    },
    sortServices() {
      var options = this.shippingOptions.sort(function(a, b) {
        return a.total_amount - b.total_amount;
      });
      //this.setShippingOptions(options)
    },
    pay() {
      const requestBody = {
        selected_service: {
          carrier: this.selectedShippingOption.carrier,
          date: this.selectedShippingOption.date,
          carrier_logo_url: this.selectedShippingOption.carrier_logo_url,
          carrier_logo_url_svg: this.selectedShippingOption
            .carrier_logo_url_svg,
          net_total_amount: this.selectedShippingOption.net_total_amount,
          total_amount: this.selectedShippingOption.total_amount,
          estimated_delivery: this.selectedShippingOption.estimated_delivery,
          total_transit_days: this.selectedShippingOption.total_transit_days,
          carrier_service_name: this.selectedShippingOption
            .carrier_service_name,
          currency: this.selectedShippingOption.currency
        },
        shipment_type: this.quotingRequestBody.package_type,
        parcels: this.quotingRequestBody.parcels,
        origin_direction: this.origin_direction,
        destination_direction: this.destination_direction,
        description_of_the_content: this.description_of_the_content
      };
    },
    getCity(directions) {
      if (directions.indexOf(",") >= 0) {
        let city = directions.split(",");
        if (city.length > 1) {
          return city[1].trim();
        }
      } else {
        return directions;
      }
    },
    getTransitInterval(transitDays,carrier, carrierServiceName, isRemote) {
      if (!isRemote) {
        if (carrierServiceName === "EXPRESS DOMESTIC 10:30") {
          return "Día siguiente antes de las 10:30";
        } else if (carrierServiceName === "EXPRESS DOMESTIC 12:00") {
          return "Día siguiente antes de las 12:30";
        } else if (carrierServiceName === "EXPRESS DOMESTIC") {
          return "Día siguiente";
        } else if (carrierServiceName === "ECONÓMICO") {
          return "De 1 a 4 Días";
        } else if (carrierServiceName === "EXPRESS" && carrier !== "ampm") {
          return "Día siguiente";
        } else if (carrierServiceName === "ECOEXPRESS") {
          return "Estándar 1 a 5 días";
        } else if (carrierServiceName === "Standard Overnight") {
          return "De 1 a 2 Días ";
        } else if (carrierServiceName === "FedEx Economy") {
          return "De 1 a 4 Días";
        } else if (carrierServiceName === "Priority Overnight") {
          return "Día siguiente";
        }  else if (carrierServiceName === "EXPRESS" && carrier === "ampm") {
          return "Expréss 1 a 2 días";
        } else if (carrierServiceName === "ESTANDAR") {
          return "Estándar 2 a 6 días";
        } else if (carrierServiceName === "Envío Economico" && carrier == "Estafeta") {
         return "De 3 a 5 Días";
        }
        else if (carrierServiceName === "TERRESTRE" && carrier == "Estafeta") {
          return "De 1 a 5 días";
        }
        else if (carrierServiceName === "TERRESTRE" && carrier == "fedex") {
          return "De 2 a 5 días";
        }
        else if (carrierServiceName.toUpperCase() === "STANDARD_OVERNIGHT") {
         return "De 1 a 2 días";
       }
       else if (carrierServiceName.toUpperCase() === "FEDEX_EXPRESS_SAVER") {
         return "De 2 a 5 días";
       }
       else if (carrierServiceName.toUpperCase() === "J&TEXPRESS") {
         return "De 2 a 5 días";
       }
       else if (carrierServiceName.toUpperCase() === "ENVÍO ECONOMICO" && carrier.toUpperCase() == "REDPACK") {
         return "De 2 a 5 días";
       }
        else {
          return "Día siguiente";
        }
      } else {
        return "Entrega en un área Remota";
      }
    },
    getTransitIntervalAlt(transitDays) {
      if (transitDays >= 0 && transitDays <= 1) {
        return "1-2";
      } else if (transitDays >= 1 && transitDays <= 2) {
        return "1-2";
      } else if (transitDays >= 2 && transitDays <= 4) {
        return "2-4";
      } else if (transitDays >= 2 && transitDays <= 5) {
        return "2-5";
      }
    },
    filter(visibleCarriers, visibleShipmentSpeed) {
      const op = this.shippingOptions.filter(sp => {
        if (
          visibleCarriers.includes(sp.carrier) &&
          visibleShipmentSpeed.includes(
            this.getTransitIntervalAlt(sp.total_transit_days)
          )
        ) {
          return true;
        }

        return false;
      });

      this.visibleShipmentOptions = op;
    },
    setOrigin(country) {
      this.origin = country;
    },
    nextStep() {
      if (this.currentStep === 1 && this.selectedShippingOptionIndex < 0) {
        return;
      }
      if (this.currentStep < 6) {
        this.step++;
      }
    },
    catchOption(index) {
     if (localStorage.getItem("ew-user-id") !== null)
     {
        //si los usuarios no están bloqueados
        if(this.user.active == true && this.idUser != "635722ca498b59763159eb99" && this.idUser != "634df378498b597631b2bf34" && this.idUser != "6359be1b498b5976318f5013"
        && this.idUser != "636297ddffe03f3b69032fa7" && this.idUser != "633337bf0aaf5a4ea81a71f4" && this.user.email != 'arguellom1324@gmail.com')
        {
          this.selectedShippingOptionIndex = index;
          this.setSelectedShippingOption(
            this.visibleShipmentOptions[this.selectedShippingOptionIndex]
          );
          this.getOverWeight();
          this.nextStep();
        }
      }
      else
      {
        window.location.href = '/signin';
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.step--;
      }
    },
    getOverWeight()
    {
      this.overweight = 0;
      this.cost_overweight = 0;
      this.netPrice = this.selectedShippingOption.total_amount;
      this.total = this.selectedShippingOption.total_amount;
      if (localStorage.getItem("ew-user-id") !== null) {
      console.log(`${commons.apiURL}/api/v1/shipments/all/${localStorage.getItem('ew-user-id')}/overweight`);
          axios
          .get(`${commons.apiURL}/api/v1/shipments/all/${localStorage.getItem('ew-user-id')}/overweight`)
          .then(response => {
            console.log(response.data);
            let shipmentsWithOverweight = response.data;
            for(var i = 0; i < shipmentsWithOverweight.length; i++)
            {
                if(shipmentsWithOverweight[i].overweight != null && shipmentsWithOverweight[i].cost_overweight != null)
                {
                  this.overweight += parseFloat(shipmentsWithOverweight[i].overweight);
                  this.cost_overweight += parseFloat(shipmentsWithOverweight[i].cost_overweight);
                }
            }
            this.total =  parseFloat(this.total) + parseFloat(this.cost_overweight);

          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    listAllShippingOptions() {
      this.sortServices();
      this.visibleShipmentOptions = this.shippingOptions;
      let vc = [];
      let vss = [];

      if (!this.visibleCarriers.length) {
        vc = this.availableCarriers.map(c => c.value);
      } else {
        vc = this.visibleCarriers;
      }

      if (!this.visibleShipmentSpeed.length) {
        // "1-3" nunca lo produce getTransitIntervalAlt() en este archivo (sus
        // únicas salidas reales son 1-2/2-4/2-5); "2-4" faltaba aquí, así
        // que con el filtro de velocidad ya retirado de la UI (nadie puede
        // volver a marcarlo) las opciones de 2 a 4 días se habrían ocultado
        // siempre, sin forma de mostrarlas.
        vss = ["1-2", "2-4", "2-5"];
      } else {
        vss = this.visibleShipmentSpeed;
      }
      this.filter(vc, vss);
    },
    getWeightTotal(parcels) {
      let total = 0;
      parcels.forEach(element => {
        total = total + parseFloat(element.weight);
      });
      return total;
    },
    saveShipment() {
      this.$v.origin_direction.$touch()
      this.$v.destination_direction.$touch()
      this.$v.description_of_the_content.$touch()
      if (this.$v.origin_direction.$invalid || this.$v.destination_direction.$invalid || this.$v.description_of_the_content.$invalid) {
        return
      }
      this.newShip = true;
      this.setSelectedShippingOption(
        this.visibleShipmentOptions[this.selectedShippingOptionIndex]
      );
      if (this.ecommerceShipment) {
        this.shipment_ecommerce = {
          order_id: this.ecommerceShipment.numberOfOrde
            ? this.ecommerceShipment.numberOfOrde
            : null,
          ecommerce_type: this.ecommerceShipment.ecommerce_type
            ? this.ecommerceShipment.ecommerce_type
            : null
        };
      }
      console.log(this.countryDes);
      this.destination_direction.country_code = this.countryDes;
      this.origin_direction.address =    this.origin_direction.address + ', ' +  this.origin_direction.number + (this.origin_direction.intNumber.length > 0 ?  ', ' + this.origin_direction.intNumber : '')
      this.destination_direction.address =    this.destination_direction.address + ', ' +  this.destination_direction.number + (this.destination_direction.intNumber.length > 0 ?  ', ' + this.destination_direction.intNumber : '')

      const requestBody = {
        selected_service: {
          carrier: this.selectedShippingOption.carrier,
          date: this.selectedShippingOption.date,
          carrier_logo_url: this.selectedShippingOption.carrier_logo_url,
          carrier_logo_url_svg: this.selectedShippingOption
            .carrier_logo_url_svg,
          net_total_amount: this.selectedShippingOption.net_total_amount,
          total_amount: parseFloat(this.selectedShippingOption.total_amount) + parseFloat(this.cost_overweight),
          estimated_delivery: this.selectedShippingOption.estimated_delivery,
          total_transit_days: this.selectedShippingOption.total_transit_days,
          carrier_service_name: this.selectedShippingOption
            .carrier_service_name,
          carrier_code: this.selectedShippingOption.carrier_code
            ? this.selectedShippingOption.carrier_code
            : "",
          currency: this.selectedShippingOption.currency
        },
        shipment_type: this.quotingRequestBody.package_type,
        parcels: this.quotingRequestBody.parcels,
        origin_direction: this.origin_direction,
        destination_direction: this.destination_direction,
        description_of_the_content: this.description_of_the_content,
        package_insurance: this.package_insurance,
        insurance_information: this.insurance_information,
        customer_info:
        {
          email: this.user.email,
          first_names: this.user.first_names,
          last_names: this.user.last_names
        },
        user: this.idUser,
        shipment_ecommerce: this.shipment_ecommerce
      };

      axios
        .post(`${commons.apiURL}/api/v1/shipments/home`, requestBody)
        .then(response => {
          this.shipmentId = response.data._id;
          this.getLinkPaypal();
          this.getLinkPaypalPlus();
          this.nextStep();
          this.setNewShipmentEcommerce(null);

          if(this.saveLocationOrigen)
          {
            this.registerAdressOrigen();
          }
          if(this.saveLocationDestination)
          {
            this.registerAdressDestination();
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    setSaveLocationOrigen()
    {
      this.saveLocationOrigen = !this.saveLocationOrigen;
    },
    setSaveLocationDestination()
    {
      this.saveLocationDestination = !this.saveLocationDestination;
    },
    registerAdressDestination()
    {
      axios
        .post(`${commons.apiURL}/api/v1/locations-user`, {
          name: this.destination_direction.full_name,
          email: this.destination_direction.email,
          phone: this.destination_direction.phone,
          address: this.destination_direction.address,
          colony: this.destination_direction.colony.trim().trim(),
          reference_of_origin: this.destination_direction.reference_of_origin,
          postal_code: this.destination_direction.postal_code.trim(),
          city: this.getCity(this.destination_direction.city.trim()),
          user: this.idUser,
          country_code: this.destination_direction.country_code
        })
        .then(response => {
            console.log('destination save');
        })
        .catch(error => {
          console.error(error)
        })
    },
    registerAdressOrigen()
    {
      axios
        .post(`${commons.apiURL}/api/v1/locations-user`, {
          name: this.origin_direction.full_name,
          email: this.origin_direction.email,
          phone: this.origin_direction.phone,
          address: this.origin_direction.address,
          colony: this.origin_direction.colony.trim(),
          reference_of_origin: this.origin_direction.reference_of_origin,
          postal_code: this.origin_direction.postal_code.trim(),
          city: this.getCity(this.origin_direction.city.trim()),
          user: this.idUser,
          country_code: this.origin_direction.country_code
        })
        .then(response => {
              console.log('origen save');
        })
        .catch(error => {
          console.error(error)
        })
    },
    deleteShipment() {
      this.newShip = false;
      axios
        .delete(`${commons.apiURL}/api/v1/shipments/${this.shipmentId}`)
        .then(response => {
          this.prevStep();
        })
        .catch(error => {
          console.error(error);
        });
    },
    getLinkPaypal(){
      axios
        .post(
          `${commons.apiURL}/api/v1/payments/${this.shipmentId}?email=${this.user.email}`
        )
        .then(response => {
          this.paypalLink = response.data.url;
        });
    },
    getLinkPaypalPlus(){
      service.shipment.getPaypalLink(this.shipmentId).then((response)=>{
        let data = response.data.data;
        if (data) {
         this.paypalpluslink = data.link;
         this.payment_id = data.payment_id;
        }
      }).catch((error)=>{
        this.paypalpluslink = ""
      })
    },
    getStatusSesion() {
      if (localStorage.getItem("ew-user-id") !== null) {
        this.idUser = localStorage.getItem("ew-user-id");
        this.isLoging = true;
      } else {
        this.idUser = null;
        this.isLoging = false;
      }
    },
    ...mapMutations([
      "netNewShipmentRequestBody",
      "setQuotingRequestBody",
      "setSelectedShippingOption",
      "setNewShipmentRequestBody",
      "setShippingOptions",
      "setNewShipmentEcommerce"
    ]),
    ...mapActions(["quoting", "newShipment", "getAllShipments"]),
    addEventPixeleFacebook() {
      fbq("track", "InitiateCheckout");
    },
    initIframePayPalPlus(){
      this.paypalplay = PAYPAL.apps.PPP({
        approvalUrl: this.paypalpluslink,
        placeholder: "ppplusDiv",
        mode: "live",
        payerEmail:`${this.user.email}`,
        payerFirstName: `${this.user.first_names}`,
        payerLastName: `${this.user.last_names}`,
        payerPhone: `${this.origin_direction.phone}`,
        payerTaxId: "",
        payerTaxIdType: "",
        country: "MX",
        language:"es_MX",
        miniBrowser:true,
        buttonLocation:"inside",
        disallowRememberedCards:true,
        onMiniBrowserClose:function () {
          console.log("close")
        },
        onContinue:(rememberedCards, payer_id, token) => {
          let email = this.user.email;
          api.shipment.executePayment(this.payment_id, payer_id, this.shipmentId, email).then((response)=>{
            let data = response.data.data;
            if (data.execute) {
                this.$router.push({path: `/payments/result/success?home=true&email=${email}`});
            }else{
                this.$router.push({path: "/payments/result/error"});
            }
          }).catch((error)=>{
              this.$router.push({path: "/payments/result/error"});
          })
        },
        onError: function (err) {
          this.$router.push({path: "/payments/result/error"});
        },
        onLoad:function(){
          console.log("carga realizada con exito")
        }
      });
    },
  },
  computed: {
    currentStep() {
      return this.step;
    },
    ...mapGetters([
      "quotingRequestBody",
      "selectedShippingOption",
      "serviceProviders",
      "shippingOptions",
      "isLoadingShippingOptions",
      "ecommerceShipment",
      "countryDes"
    ])
  },
  validations: {
    origin_direction: {
      full_name: { required, minLength: minLength(2), maxLength: maxLength(35) },
      phone: { required },
      email: { required, email },
      address: { required, minLength: minLength(2), maxLength: maxLength(25) },
      number: { required },
      colony: { required, maxLength: maxLength(35) },
      postal_code: { required, maxLength: maxLength(12) }
    },
    destination_direction: {
      full_name: { required, minLength: minLength(2), maxLength: maxLength(35) },
      phone: { required },
      email: { required, email },
      address: { required, minLength: minLength(2), maxLength: maxLength(25) },
      number: { required },
      colony: { required, minLength: minLength(5), maxLength: maxLength(35) },
      postal_code: { required, maxLength: maxLength(12) }
    },
    description_of_the_content: { required }
  },
  mounted() {
    this.weightTotal = this.getWeightTotal(this.quotingRequestBody.parcels);
    this.destination_direction.postal_code = this.quotingRequestBody.destination_direction.postal_code;
    this.destination_direction.country_code = this.quotingRequestBody.destination_direction.country_code;
    if (this.destination_direction.postal_code !== "") {
      if (this.destination_direction.country_code !== "MX") {
        service.shipment
          .getPostalCodes(
            this.destination_direction.country_code,
            this.destination_direction.postal_code
          )
          .then(response => {
            this.destination_direction.city =
              response.data[0].state + ", " + response.data[0].city;
          });
      } else {
        axios
          .get(
            `${commons.apiURL}/api/v1/postalcodes?search=${this.destination_direction.postal_code}&country=MX`
          )
          .then(response => {
            this.destination_direction.city =
              response.data.country_codes[0].state +
              ", " +
              response.data.country_codes[0].city;
          });
      }
    }
    if (this.origin_direction.postal_code !== "") {
      axios
        .get(
          `${commons.apiURL}/api/v1/postalcodes?search=${this.origin_direction.postal_code}&country=MX`
        )
        .then(response => {
          this.origin_direction.city =
            response.data.country_codes[0].state +
            ", " +
            response.data.country_codes[0].city;
        });
    }
    if (window.addEventListener) {
    window.addEventListener("message", this.messageListener, false);
      console.log("addEventListener successful", "debug");
    } else if (window.attachEvent) {
    window.attachEvent("onmessage", this.messageListener);
      console.log("attachEvent successful", "debug");
    } else {
      console.log("Could not attach message listener", "debug");
    throw new Error("Can't attach message listener");
    }
  },
  created() {
    /** Verificar que tipo de envios se cotizara */
    if (this.ecommerceShipment) {
      this.destination_direction.full_name = this.ecommerceShipment
        .destination_direction.full_name
        ? this.ecommerceShipment.destination_direction.full_name
        : "";
      this.destination_direction.email = this.ecommerceShipment
        .destination_direction.email
        ? this.ecommerceShipment.destination_direction.email
        : "";
      this.destination_direction.phone = this.ecommerceShipment
        .destination_direction.phone
        ? this.ecommerceShipment.destination_direction.phone
        : "";
      this.destination_direction.address = this.ecommerceShipment
        .destination_direction.address
        ? this.ecommerceShipment.destination_direction.address
        : "";
    }
    /** Verificar que tipo de envios se cotizara */
    /** Verificar que la sesion este activa */
    this.getStatusSesion();
    /** Verificar que la sesion este activa */

    if (this.isLoging) {
      axios
        .get(`${commons.apiURL}/api/v1/users/${this.idUser}`)
        .then(response => {
          this.user.email = response.data.email;
          this.user.first_names = response.data.firstName;
          this.user.last_names = response.data.lastName;
          this.user.active = response.data.active;
        })
        .catch(error => {
          console.trace(error);
        });
    }

    this.quoting().then(response => {
      this.listAllShippingOptions();
    });
    axios.get(`${commons.apiURL}/api/v1/countrycodes`).then(response => {
      this.countries = response.data.country_codes;
      this.quotingLocked = false;
      // console.log(response.data.country_codes)
    });

    this.origin_direction.postal_code = this.quotingRequestBody.origin_direction.postal_code;
    this.destination_direction.postal_code = this.quotingRequestBody.destination_direction.postal_code;
    this.origin_direction.city = this.quotingRequestBody.origin_direction.city;
    this.destination_direction.city = this.quotingRequestBody.destination_direction.city;
    this.origin_direction.colony = this.quotingRequestBody.origin_direction.suburb;
    this.destination_direction.colony = this.quotingRequestBody.destination_direction.suburb;
    console.log(
      "state_short",
      this.quotingRequestBody.destination_direction.state_short
    );
    this.destination_direction.state_short = this.quotingRequestBody.destination_direction.state_short;
  },
  components: {
    navbar: Navbar,
    "footer-simple": FooterSimple
  }
};
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }
.ew-page__body { padding: 1.75rem 2rem 3rem; max-width: 1200px; margin: 0 auto; }
.ew-card { @include ew-card; }
.ew-wizard { padding: 1.5rem 1.75rem 2rem; }
.ew-card-title { @include ew-card-title; margin-bottom: 1rem; }
.ew-section-title {
  margin: 0 0 1.25rem;
  font-family: var(--app-font);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--app-navy);
}

/* Stepper -------------------------------------------------------------- */
.ew-stepper { @include ew-stepper; }
.ew-stepper__step { @include ew-stepper-step; }
.ew-stepper__index { @include ew-stepper-index; }
.ew-stepper__line { @include ew-stepper-line; }

/* Formularios compartidos ------------------------------------------------ */
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; margin-bottom: 1rem; }
.ew-form__row { display: flex; flex-wrap: wrap; gap: 1rem; > .ew-form__field { flex: 1 1 160px; min-width: 0; } }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-field-error { @include ew-field-error; }
.ew-input--block { width: 100%; }
.ew-checkbox-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.25rem;
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-navy-secondary);
  cursor: pointer;
}
.ew-checkbox { @include ew-checkbox; }
.ew-wizard__actions {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 1.5rem;
  &--end { justify-content: flex-end; }
}
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }

/* Loading ------------------------------------------------------------- */
.ew-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  padding: 6rem 1.5rem;
  text-align: center;
  font-family: var(--app-font);
  font-weight: 700;
  color: var(--app-navy);
  min-height: 100vh;

  img { width: 4rem; height: auto; }
}

/* Paso 1: selección de servicio ------------------------------------------ */
.ew-carrier-list { display: flex; flex-direction: column; gap: 0.9rem; }
.ew-carrier-card { @include ew-carrier-card; }
.ew-carrier-card__logo { @include ew-carrier-card-logo; }
.ew-carrier-card__info { @include ew-carrier-card-info; }
.ew-carrier-card__price { @include ew-carrier-card-price; }
.ew-area-remote { color: #C8102E; }

.ew-price-breakdown { min-width: 12rem; font-family: var(--app-font); font-size: 0.82rem; }
.ew-price-breakdown__row { display: flex; justify-content: space-between; gap: 1rem; padding: 0.2rem 0; color: var(--app-navy-secondary); }
.ew-price-breakdown__total { display: flex; justify-content: space-between; gap: 1rem; padding-top: 0.4rem; margin-top: 0.3rem; border-top: 1px solid var(--app-border); font-weight: 700; color: var(--app-navy); }

.ew-empty { @include ew-empty; }
.ew-empty__text { @include ew-empty-text; }
.ew-empty__image { max-width: 9rem; height: auto; margin-bottom: 0.5rem; }

/* Resumen del pedido: presente en los 3 pasos, columna derecha ----------- */
.ew-step-layout { display: grid; grid-template-columns: 1fr 19rem; align-items: start; gap: 1.5rem; @media (max-width: 960px) { grid-template-columns: 1fr; } }
.ew-step-layout__aside { @media (max-width: 960px) { order: -1; } }

// Quiebre alto a propósito: con la columna de resumen (19rem) restándole
// espacio real al contenido principal, un quiebre de 800px dejaba las dos
// columnas de dirección aplastadas entre ~900-1300px de viewport.
.ew-addr-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1.25rem; margin-bottom: 1.5rem; @media (max-width: 1320px) { grid-template-columns: 1fr; } }
.ew-address-panel { border-radius: var(--app-radius-md); overflow: hidden; }
.ew-address-panel__header { @include ew-address-panel-header; }
.ew-address-panel__body { @include ew-address-panel-body; }

// El selector de país se quitó (ver PENDIENTES.md): en la práctica solo
// México funcionaba, un dropdown "interactivo" que no cambia nada es peor
// que no tener dropdown. Queda como insignia fija informativa.
.ew-flag-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.15);
  font-family: var(--app-font);
  font-size: 0.78rem;
  font-weight: 700;
  color: #fff;
}
.ew-flag { width: 1.25rem; height: auto; border-radius: 2px; }

.ew-content-card { margin-bottom: 1.5rem; }

.ew-summary-card { @include ew-summary-card; }
.ew-summary-card__carrier {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--app-border);
  img { width: 4rem; height: auto; }
  p { margin: 0; font-family: var(--app-font); font-weight: 700; color: var(--app-navy); font-size: 0.9rem; }
}
.ew-summary-route { margin-bottom: 1rem; }
.ew-summary-route__row {
  display: flex;
  gap: 0.75rem;
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-navy-secondary);
  margin-bottom: 0.5rem;
  span:first-child { font-weight: 700; color: var(--app-navy); flex-shrink: 0; }
  p { margin: 0; }
}
.ew-summary-row { @include ew-summary-row; }
.ew-summary-total { @include ew-summary-total; }

/* Paso 3: pago ------------------------------------------------------------*/
.ew-pay-card { display: flex; flex-direction: column; }
.ew-pay-options { display: flex; flex-direction: column; gap: 0.75rem; margin-bottom: 1rem; }
.ew-pay-option { @include ew-pay-option; }
.ew-pay-hint {
  margin: -0.25rem 0 1rem;
  padding: 0.65rem 0.85rem;
  border-radius: var(--app-radius-sm);
  background: var(--app-surface-muted);
  font-family: var(--app-font);
  font-size: 0.8rem;
  color: var(--app-navy-secondary);
}
.ew-pay-security {
  margin: 0.85rem 0 0;
  font-family: var(--app-font);
  font-size: 0.75rem;
  color: var(--app-muted);
  text-align: right;
}
</style>

<style lang="scss">
// Footer de marketing: sin tocar, hereda el estilo global tal cual lo traía
// (esta pantalla comparte layout con Home.vue, que aún no se ha rediseñado —
// ver PENDIENTES.md). No usar aquí el sistema de tokens del wizard.
@import "../assets/styles/variables";
@media (max-width: 375px) {
  .col-5.ew-text-warranty {
    flex: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewShipmentFlowFromHome.vue